import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { State } from '@cemex/cmx-client-layout';

import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { SelectOptionI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-multiselect/models/select-option-i';
import { SelectOptionLoaderI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { getApplications } from '@ordersnproducts/modules/multiple-order-online/redux/selectors/orders-catalogs.selector';

@Injectable()
export class ApplicationsLoaderService implements SelectOptionLoaderI {
  constructor(private store: Store<State>) {
    //
  }

  /**
   * Provides an observable of the elements
   * @return {Observable<SelectOptionI[]>}
   */
  loadOptions(formGroup: UntypedFormGroup): Observable<SelectOptionI[]> {
    const options$ = this.store.select(getApplications).pipe(
      filter((applications) => applications !== undefined),
      map((applications) => {
        if (applications.length) {
          return applications.map((application) => {
            return {
              id: application.applicationCode,
              name: `${application.applicationDesc}`,
            };
          });
        }
        return [];
      }),
    );
    return options$;
  }
}
